(function(){
  'use strict';

  // Sticky nav
  var nav = document.getElementById('GbNav');
  if(nav){
    window.addEventListener('scroll', function(){
      nav.classList.toggle('scrolled', window.scrollY > 60);
    },{passive:true});
  }

  // Hamburger
  var ham = document.getElementById('GbHam');
  var mob = document.getElementById('GbMobile');
  if(ham && mob){
    ham.addEventListener('click', function(){
      var open = mob.classList.toggle('open');
      ham.setAttribute('aria-expanded', open);
      var spans = ham.querySelectorAll('span');
      spans[0].style.transform = open ? 'rotate(45deg) translate(5px,5px)' : '';
      spans[1].style.opacity = open ? '0' : '1';
      spans[2].style.transform = open ? 'rotate(-45deg) translate(5px,-5px)' : '';
    });
    document.addEventListener('click', function(e){
      if(!ham.contains(e.target) && !mob.contains(e.target)){
        mob.classList.remove('open');
        ham.setAttribute('aria-expanded','false');
        ham.querySelectorAll('span').forEach(function(s){s.style.transform='';s.style.opacity='';});
      }
    });
  }

  // FAQ accordion
  document.querySelectorAll('.gb-faq-q').forEach(function(q){
    q.addEventListener('click', function(){
      var item = q.closest('.gb-faq-item');
      var wasOpen = item.classList.contains('open');
      document.querySelectorAll('.gb-faq-item.open').forEach(function(i){i.classList.remove('open');});
      if(!wasOpen) item.classList.add('open');
    });
  });

  // Scroll reveal
  if('IntersectionObserver' in window){
    var io = new IntersectionObserver(function(entries){
      entries.forEach(function(e){
        if(e.isIntersecting){e.target.classList.add('visible');io.unobserve(e.target);}
      });
    },{threshold:0.08,rootMargin:'0px 0px -30px 0px'});
    document.querySelectorAll('.reveal').forEach(function(el){io.observe(el);});
  } else {
    document.querySelectorAll('.reveal').forEach(function(el){el.classList.add('visible');});
  }

})();
